import { SchoolYearProvider } from '@pelckmans/business-components/context/SchoolYearContext';
import { FeatureTogglesContextProvider } from './contexts/FeatureTogglesContext';
import { IdentityContextProvider } from './contexts/IdentityContext';
import { GoogleAnalyticsContextProvider } from './contexts/GoogleAnalyticsContext';
import { InvitationContextProvider } from './contexts/InvitationContext';
import { AccountContextProvider } from './contexts/AccountContext';
import { LicenseTransferContextProvider } from './contexts/LicenseTransferContext';
import { UserImagesContextProvider } from './contexts/UserImagesContext';
import { MyAssignmentsContextProvider } from './contexts/MyAssignmentsContext';
import { PropsWithRequiredChildren } from '@pelckmans/elementis/@types/react';
import { UserModuleContextProvider } from './contexts/UserModuleContext';

export default function AppDataProvider({ children }: PropsWithRequiredChildren) {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  return (
    <FeatureTogglesContextProvider studioGroup={REACT_APP_P_STUDIO_GROUP}>
      <GoogleAnalyticsContextProvider>
        <IdentityContextProvider>
          <AccountContextProvider>
            <InvitationContextProvider>
              <LicenseTransferContextProvider>
                <UserImagesContextProvider>
                  <MyAssignmentsContextProvider>
                    <UserModuleContextProvider>
                      <SchoolYearProvider studioGroup={REACT_APP_P_STUDIO_GROUP}>{children}</SchoolYearProvider>
                    </UserModuleContextProvider>
                  </MyAssignmentsContextProvider>
                </UserImagesContextProvider>
              </LicenseTransferContextProvider>
            </InvitationContextProvider>
          </AccountContextProvider>
        </IdentityContextProvider>
      </GoogleAnalyticsContextProvider>
    </FeatureTogglesContextProvider>
  );
}
